/**
 * @author: lv.chen
 * @date: 2025/8/8
 * @desc: ReportUploader组件
 */
import React from 'react';
import { useIntl } from 'umi';
import { Button } from 'tea-component';
import SvgIcon from '@home/components/SvgIcon';
import ReportUploaderCore from '@home/components/ReportUploader';

import './index.scss';

interface IReportUploaderProps extends IBaseProps {
  recognize: (file: File, options: { onProgress: (progress: { percent: number }) => void }) => Promise<any>;
  onRecognized?: (file: File, result: IRecord | null) => void;
  onRecognitionError?: (file: File, error: unknown) => void;
}

const ReportUploader: React.FC<IReportUploaderProps> = (props) => {
  const { ...restProps } = props;

  const { formatMessage } = useIntl();

  return (
    <ReportUploaderCore
      {...restProps}
      button={
        <Button className="dbu-report-uploader-button">
          <SvgIcon type="upload" />
          <span>{formatMessage({ id: 'dbu_common_upload' })}</span>
        </Button>
      }
    />
  );
};

export default ReportUploader;
